import React from "react";
import styles from "./index.module.less";

const hintPlacementClass = (tip, placement) => {
  if (!tip) return "";
  const p = placement || "top";
  const allowed = ["top", "bottom", "left", "right", "bottom-left", "bottom-right", "top-left", "top-right"];
  const valid = allowed.includes(p) ? p : "top";
  return `hint--${valid}`;
};

const XtButton = ({children, className, href, tip, tipPlacement, onClick}) => {
  const hintClass = hintPlacementClass(tip, tipPlacement);
  return href ? <a href={href} className={`${styles["xt-btntxt"]} ${className} ${hintClass}`} aria-label={tip} onClick={onClick}>
    {children}
  </a> : <button className={`${styles["xt-btntxt"]} ${className} ${hintClass}`} aria-label={tip} onClick={onClick}>
    {children}
  </button>;
}
export default XtButton;